module.exports = __webpack_public_path__ + "media/images/icon/ico_platinum-e97ccf6bac92cb50f0421b7b9410a73b.svg";